import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const NoComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg width="135" height="134" viewBox="0 0 135 134" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <linearGradient x1="49.968%" y1="-2.316%" x2="49.968%" y2="101.076%" id="qm2aggp86c">
          <stop offset="0%" stopColor="#FDFEFF" />
          <stop offset="99.64%" stopColor="#ECF0F5" />
        </linearGradient>
        <filter
          x="-55.5%"
          y="-39%"
          width="211%"
          height="209.2%"
          filterUnits="objectBoundingBox"
          id="mczbwxo42a"
        >
          <feOffset dy="11" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="11" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M34.756 0C15.536 0 0 13.93 0 31.09 0 41 5.179 49.87 13.235 55.51v12.9c0 1.73 1.956 2.77 3.337 1.61L27.62 61.5c2.302.46 4.604.69 7.02.69 19.22 0 34.756-13.93 34.756-31.1C69.396 13.93 53.86 0 34.756 0z"
          id="0y58qohbgb"
        />
      </defs>
      <g fill="none">
        <path
          d="M69.7 115.6c28.003 0 50.703-22.7 50.703-50.8 0-28.1-22.7-50.8-50.703-50.8C41.7 14 19 36.7 19 64.8c0 28.1 22.7 50.8 50.7 50.8zM122.503 35.9a4.1 4.1 0 1 0 0-8.2c-2.27 0-4.1 1.83-4.1 4.1a4.1 4.1 0 0 0 4.1 4.1zM124.503 15.8c1.54 0 2.8-1.26 2.8-2.8 0-1.55-1.26-2.8-2.8-2.8-1.55 0-2.8 1.25-2.8 2.8 0 1.54 1.25 2.8 2.8 2.8zM9.8 31.8c1.546 0 2.8-1.26 2.8-2.8 0-1.55-1.254-2.8-2.8-2.8C8.254 26.2 7 27.45 7 29c0 1.54 1.254 2.8 2.8 2.8z"
          fill="#EAEEF9"
        />
        <path
          d="M87.253 31.38c17.263 0 31.183 12.55 31.183 27.99 0 8.87-4.6 16.81-11.85 22V93c0 1.61-1.84 2.42-2.99 1.5l-9.9-7.72c-2.07.34-4.141.58-6.328.58-17.263 0-31.188-12.56-31.188-27.99 0-15.44 13.925-27.99 31.073-27.99z"
          fill="#CBD4E0"
        />
        <g transform="translate(22 30)">
          <use fill="#000" filter="url(#mczbwxo42a)" xlinkHref="#0y58qohbgb" />
          <use fill="url(#qm2aggp86c)" xlinkHref="#0y58qohbgb" />
        </g>
        <path
          d="M45.42 62.36c2.097 0 3.798-1.7 3.798-3.8a3.799 3.799 0 1 0-7.596 0c0 2.1 1.7 3.8 3.798 3.8zM66.941 62.36c2.097 0 3.797-1.7 3.797-3.8a3.798 3.798 0 1 0-7.595 0c0 2.1 1.7 3.8 3.798 3.8zM60.956 74.46c-.345 0-.69-.12-.921-.47-.92-1.26-2.301-1.95-3.912-1.95-1.497 0-2.993.69-3.798 1.95-.345.58-1.036.7-1.611.23-.576-.34-.691-1.03-.231-1.61 1.266-1.84 3.453-2.99 5.755-2.99 2.301 0 4.373 1.15 5.754 2.99.345.58.23 1.27-.23 1.61-.346.24-.576.24-.806.24z"
          fill="#989FB0"
        />
        <path
          d="M46.342 27.13h-.417c-.694-.27-1.11-.97-.971-1.66l2.359-7.64c.277-.7.971-1.11 1.665-.97.694.27 1.11.97.971 1.66l-2.22 7.64c-.139.56-.694.97-1.387.97zM40.514 28.8c-.556 0-1.111-.42-1.388-.97l-3.608-10.97c-.277-.7.139-1.53.833-1.81.693-.28 1.526.14 1.804.83l3.607 10.98c.278.69-.138 1.52-.832 1.8-.139.14-.278.14-.416.14zM35.102 31.44c-.416 0-.694-.14-.972-.42l-4.44-4.3c-.555-.56-.555-1.39 0-1.95a1.35 1.35 0 0 1 1.943 0l4.44 4.31c.555.55.555 1.39 0 1.94-.277.28-.694.42-.971.42z"
          fill="#B5BCCE"
        />
      </g>
    </svg>
  );
};

NoComment.displayName = 'NoComment';
